import React from 'react';
import { useSelector } from 'react-redux';
import { labelsSelector } from 'src/redux/app/selectors';

const factoryDefault = val => val;

const Label = ({ name, fallback, className, factory = factoryDefault }) => {
  const labels = useSelector(labelsSelector);

  const labelValue = factory(labels[name] || fallback || name);

  return className ? <span className={className}>{labelValue}</span> : <>{labelValue}</>;
};

export default Label;
